export default __webpack_public_path__ + "static/media/liberty-wing.d48dac40.png";